import React, { useEffect } from "react";
import { useLocation } from "react-router";
import {
    onCLS, onFCP, onFID, onINP, onLCP, onTTFB, Metric,
} from "web-vitals";
import { LoggingHandler } from "./LoggingContext";

(() => {
    const handleReport = (metric: Metric) => {
        LoggingHandler.instance.debug({ metric }, "Web Vitals Report");
    };
    onCLS(handleReport);
    onFCP(handleReport);
    onFID(handleReport);
    onINP(handleReport);
    onLCP(handleReport);
    onTTFB(handleReport);
})();

export default function PageMonitor() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split("/").filterFalsy();
        LoggingHandler.instance.metric([LoggingHandler.Metrics.PAGE_VIEW, ...path].filterNull());
    }, [location.pathname]);

    return null;
}
